import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Button, message } from "antd";
import { SwapRightOutlined } from "@ant-design/icons";
import { errorHandler } from "utility/functions/errorHandler";
import { useTranslation } from "react-i18next";
import { InputPassword, InputPlug } from "./style";
import {
  useOutletContext,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { apiRegister, apiGetOtp } from "api/api";

import PhoneInput from "components/PhoneInput";

const Register = () => {
  const { i18n, t } = useTranslation();
  const [info, success, warning, error] = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const isLogIn =
    sessionStorage._skyFilm_t && sessionStorage._skyFilm_t.length > 0;

  useEffect(() => {
    if (isLogIn) {
      if (redirect) {
        navigate(redirect, { replace: true });
      } else {
        navigate("/home", { replace: true });
      }
    }
  }, [isLogIn, navigate, redirect]);

  const onFinish = async (values) => {
    values.username = values.email;
    setIsLoading(true);
    try {
      const res = await apiGetOtp({ email: form.getFieldValue("email2") });
      sessionStorage.r_info = JSON.stringify(values);
      sessionStorage.r_key = res?.data?.content;
      // 保留 redirect 參數帶到 OTP 頁
      if (redirect) {
        navigate(`/confirm-email-otp?redirect=${encodeURIComponent(redirect)}`);
      } else {
        navigate("/confirm-email-otp");
      }
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row>
      <Col
        sm={{ span: 8, offset: 8 }}
        xs={{ span: 24 }}
        className="mobile:py-8 py-20 px-2 md:px-0"
      >
        <Card
          title={<h4 className="text-left">註冊Sign Up</h4>}
          extra={
            <a>
              <p className="text-right" onClick={() => navigate("/login")}>
                返回登入頁
              </p>
            </a>
          }
        >
          <Form
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
            form={form}
            initialValues={
              sessionStorage.r_info &&
              Object.keys(sessionStorage.r_info).length > 0
                ? JSON.parse(sessionStorage.r_info)
                : {}
            }
          >
            <Row gutter={16}>
              <Col sm={{ span: 24 }} xs={{ span: 24 }}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[{ required: true }]}
                >
                  <InputPlug size="large" className="p-2" placeholder="名字" />
                </Form.Item>
              </Col>
              {/* <Col sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item label="Last Name" name="last_name">
                  <InputPlug size="large" className="p-2" placeholder="姓氏" />
                </Form.Item>
              </Col> */}
              <Col span={24}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true },
                    {
                      type: "email",
                    },
                  ]}
                >
                  <InputPlug
                    size="large"
                    className="p-2"
                    placeholder="電子郵件 Email"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Confirm Email"
                  name="email2"
                  rules={[
                    { required: true },
                    {
                      type: "email",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("email") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("您輸入的Email與先前不同"),
                        );
                      },
                    }),
                  ]}
                >
                  <InputPlug
                    size="large"
                    className="p-2"
                    placeholder="電子郵件 Email"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Mobile Phone"
                  name="phone"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <PhoneInput
                    size="large"
                    className="p-0 [&_.ant-input]:p-2"
                    placeholder="電話號碼"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Password"
                  name="password"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern:
                        /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d#?!@$%^&\-]{7,20}$/,
                      message:
                        "密碼需為7到20位，且必須同時包含英文與數字，只允許使用 #?!@$%^&- 這些符號。",
                    },
                  ]}
                >
                  <InputPassword
                    size="large"
                    className="p-2"
                    placeholder="密碼"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Confirm Password"
                  name="password2"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("您輸入的密碼與先前不同"),
                        );
                      },
                    }),
                  ]}
                >
                  <InputPassword
                    size="large"
                    className="p-2"
                    placeholder="再次輸入"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-SKF-B-001 w-full"
                loading={isLoading}
              >
                註冊
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Register;
